import React, { useState, useEffect, useRef } from "react";
import { MdDelete, MdUpload } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ROUTES, REACT_APP_API_URL } from "../../config/api-config";
import { registerStaffService } from "../../services/api-service";
import "./AddStudents.css";
import { useLocation, useHistory, useParams } from "react-router-dom";
import AutoFaceIdCamera from "./AutoFaceIdCamera";

const StaffRegistration = () => {
  const location = useLocation();
  const staff_location = location.state || {};

  const [staff_id, setStaffId] = useState(staff_location.staff_id || "");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [department, setDepartment] = useState("");
  const [email, setEmailId] = useState("");
  const [mobile_no, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  
  const [allImages, setAllImages] = useState([]);
  const [multeImage, setMulteImage] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("accessToken");
  const history = useHistory();

  // Handle multiple image selection from file input
  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
    setMulteImage((prev) => [...prev, ...files]);
  };

  // Handle image capture from camera
  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
  };

  // Convert file to base64
  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  // Add this function to handle removing a specific image
  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
    setMulteImage((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  // Handle form submission
  const handleSubmit = async () => {
    setLoading(true);

    try {
      // ✅ VALIDATION
      if (!staff_id.trim()) {
        toast.warn("Staff ID is required");
        setLoading(false);
        return;
      }

      if (!first_name.trim()) {
        toast.warn("First name is required");
        setLoading(false);
        return;
      }

      if (!last_name.trim()) {
        toast.warn("Last name is required");
        setLoading(false);
        return;
      }

      if (!department.trim()) {
        toast.warn("Role is required");
        setLoading(false);
        return;
      }

      if (allImages.length === 0) {
        toast.warn("Please upload at least one image");
        setLoading(false);
        return;
      }

      // Convert images to base64
      const images = await Promise.all(
        allImages.map((img) => {
          if (img instanceof File) {
            return readFileAsBase64(img);
          }
          return img;
        })
      );

      // ✅ Call API using service
      const response = await registerStaffService({
        staff_id: staff_id.trim(),
        first_name: first_name.trim(),
        last_name: last_name.trim(),
        department: department.trim(),
        email: email.trim(),
        mobile_no: mobile_no.trim(),
        images,
        password: password || undefined,
      });

      if (response.status === 201 || response.data) {
        toast.success("Staff Registered Successfully!");

        // Reset form
        setStaffId("");
        setFirstName("");
        setLastName("");
        setDepartment("");
        setEmailId("");
        setMobileNumber("");
        setPassword("");
        setAllImages([]);
        setMulteImage([]);

        // Redirect to staff list
        setTimeout(() => {
          history.push("/admin/FaceDetails");
        }, 1500);
      }
    } catch (error) {
      console.error("Error registering staff:", error);
      const errorMsg = error.response?.data?.detail || error.message || "Registration failed";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="container">
        <div className="form-section">
          <h2>Staff Registration</h2>

          <div className="form-group">
            <label className="lebcs">Face ID</label>
            <input
              className="Asss"
              type="text"
              value={staff_id}
              onChange={(e) => setStaffId(e.target.value)}
              placeholder="Enter Face ID"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">First Name</label>
              <input
                className="Asss"
                type="text"
                placeholder="First Name"
                value={first_name}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="lebcs">Last Name</label>
              <input
                className="Asss"
                type="text"
                placeholder="Last Name"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Role</label>
              <input
                className="Asss"
                type="text"
                placeholder="Department"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="lebcs">Email</label>
              <input
                className="Asss"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Mobile</label>
              <input
                className="Asss"
                type="number"
                placeholder="Mobile Number"
                value={mobile_no}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* --- CAMERA AND GALLERY SECTION --- */}
        <div className="camera-section">
          <h2>Live Camera</h2>
          
          <AutoFaceIdCamera onImageCapture={handleImageCapture} />

          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            
            {/* Upload Button */}
            <label style={{ 
                color: '#fff', 
                backgroundColor: '#00bcd4',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)',
                marginBottom: '15px'
              }} 
              htmlFor="staff_images"
            >
              Upload Image(s)
              <MdUpload size={20} />
              <input
                className="Asss"
                id="staff_images"
                accept=".png, .jpeg, .jpg"
                style={{ display: "none" }}
                type="file"
                multiple
                onChange={handleMultipleImageChange}
              />
            </label>

            {/* Visual Gallery with Delete Buttons Moved Here */}
            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img 
                        src={imgSrc} 
                        alt={`captured-face-${index}`} 
                        style={{ 
                          width: "100%", 
                          height: "100%", 
                          objectFit: "cover", 
                          borderRadius: "8px", 
                          border: "2px solid #00bcd4" 
                        }} 
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-6px",
                          background: "#ff4444",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "22px",
                          height: "22px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
            
          </div>
        </div>
      </div>

      <div style={{ width: "100%", paddingLeft: "172px", paddingRight: "172px", marginTop: '20px', marginBottom: '40px' }}>
        <button className="upload-btn" onClick={handleSubmit} disabled={loading} style={{ width: '100%' }}>
          {loading ? "Registering..." : "Register"}
        </button>
      </div>
    </>
  );
};

export default StaffRegistration;
